


  const end_date_timer = document.querySelector('.end_date_timer');

  if (end_date_timer) {
    // Pobieramy datę końca promocji z atrybutu data-end-date
    const endDate = new Date(end_date_timer.getAttribute('data-end-date'));
    // Funkcja do odliczania czasu
    function updateCountdown() {
        const now = new Date();
        const timeLeft = endDate - now;
        if (timeLeft > 0) {
            const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
            let countdown = '';

            if (days > 0) {
                countdown += `${days}:`;
            }
            
            if (hours > 0) {
                countdown += `${hours}:`;
            }
    
            if (minutes > 0) {
                countdown += `${minutes}:`;
            }
    
            countdown += `${seconds}`;
    
            // Aktualizujemy zawartość elementu HTML z odliczaniem
            end_date_timer.innerHTML = countdown;
        } else {
            // Wyświetlamy komunikat po zakończeniu promocji
            end_date_timer.innerHTML = '- zakończona';
        }
    }
  
    // Wywołujemy funkcję odliczania co sekundę
    setInterval(updateCountdown, 1000);
  }

